import { H2, H1 } from "@datapay-by-datacom/design-system";
import { WorkspaceScreen } from "../../workspace/components/WorkspaceScreen";
import { OrgInvitationSection } from "../components/OrgInvitationSection";
import s from "./NotificationsScreen.module.css";

export function NotificationsScreen() {
  return (
    <WorkspaceScreen>
      <div className={s.container}>
        <div className={s.header}>
          <H1>Notifications</H1>
        </div>
        <div className={s.sections}>
          <section className={s.section}>
            <div className={s.sectionTitle}>
              <H2>Organization Invitations</H2>
            </div>

            <OrgInvitationSection />
          </section>
          {/* Add more notification sections here as needed */}
        </div>
      </div>
    </WorkspaceScreen>
  );
}
